<template>
  <li class="filterable-list__list-item" data-js-item="filterable-list-list-item" tabindex="-1"
  		:id="addId" :data-js-module="item.link.overlay" >
    <div class="filterable-list__list-item-image" :class="addClass">
	  <!-- ListItem Picture -->
      <ListItemPicture :image="item.image" v-if="item.image && item.image.content.fallbackSrc != ''"/>
	  <!-- ListItem Default Picture -->
	  <ListItemDefaultPicture v-if="!item.image" />
      <!-- event card -->
      <EventCard v-if="item.category && item.category === 'events'" :item="item"/>
    </div>
    <div class="filterable-list__list-item-text-wrapper" :class="addClass">
      <em class="filterable-list__list-item-meta">
        <span class="filterable-list__list-item-meta-category">{{item.categoryHeadline}}{{'\xa0'}}</span>
        <span
          v-if="item.date != '' && item.category && item.category != 'events'"
          class="filterable-list__list-item-meta-date"
        >{{ item.date }}</span>
        <span
          v-if="item.dateDetails && item.dateDetails != '' && item.category && item.category == 'events'"
          class="filterable-list__list-item-meta-date"
        >
          <template v-for="(onedateDetail, index) in item.dateDetails">
            <template v-if="index == item.dateDetails.length - 1 && index !== 0">&nbsp;&ndash;&nbsp;</template>
            {{onedateDetail.date}}{{' '}}
          </template>
        </span>
        <span
          v-if="item.categoryAddition"
          class="filterable-list__list-item-meta-addition"
        >{{item.categoryAddition}}</span>
      </em>
	<template v-if="item.link.dataContent && item.link.dataContent != ''">
      <a
        class="filterable-list__list-item-link"
        :class="addClass"
		aria-haspopup="true"
		aria-controls="overlay"
		aria-expanded="false"
		data-js-item="overlay-handler-cta"
		:data-content="item.link.dataContent"
        :href="addIdAnker"
      >{{item.link.text}}<span v-if="item.link.info" class="filterable-list__list-item-link-info">{{item.link.info}}</span></a>
	</template>
	<template v-else>
		 <a
        class="filterable-list__list-item-link"
        :class="addClass"
        :href="item.link.href"
      >{{item.link.text}}<span v-if="item.link.info" class="filterable-list__list-item-link-info">{{item.link.info}}</span></a>
	</template>

      <template v-if="item.topicLabel && item.topicLabel != ''">
        <span class="filterable-list__list-item-topic-headline">{{item.topicLabel}}</span>
        <ul v-if="item.topics" class="filterable-list__list-item-topics">
          <li
            v-for="(topic, index) in item.topics"
            :key="index"
            class="filterable-list__list-item-topic-item"
          >{{topic.text}}</li>
        </ul>
      </template>

      <template v-if="item.time && item.time != '' && item.address && item.address != '' ">
        <div class="filterable-list__list-item-event">
          <time class="filterable-list__list-item-time">{{item.time}} {{item.timeUnit}}</time>
          <address class="filterable-list__list-item-address">{{item.address}}</address>
        </div>
      </template>

      <template v-if="item.infoline && item.infoline != ''">
        <p class="filterable-list__list-item-description" v-html="item.infoline"></p>
      </template>

      <p class="filterable-list__list-item-description">{{item.description}}</p>

      <template v-if="item.videoInfo && item.videoInfo != ''">
        <p class="filterable-list__list-item-info-video" v-html="item.videoInfo"></p>
      </template>

      <template v-if="item.deadline && item.deadline != ''">
        <strong class="filterable-list__list-item-deadline">{{item.deadlineLabel}}{{item.deadline}}</strong>
      </template>
    </div>
	<template v-if="item.link.dataContent && item.link.dataContent != ''">
		<a
		class="filterable-list__a11y-clickarea"
		aria-hidden="true"
		tabindex="-1"
		aria-haspopup="true"
		aria-expanded="false"
		data-js-item="overlay-handler-cta"
		:data-content="item.link.dataContent"
		:href="addIdAnker"
		></a>
	</template>
	<template v-else>
		<a
		class="filterable-list__a11y-clickarea"
		aria-hidden="true"
		tabindex="-1"
		:href="item.link.href"
		></a>
	</template>
  </li>
</template>


<script>
import EventCard from "./EventCard.vue";
import ListItemPicture from "./ListItemPicture.vue";
import ListItemDefaultPicture from "./ListItemDefaultPicture.vue";

export default {
  name: "FilterableItem",
  props: ["item"],
  components: {
	EventCard,
	ListItemPicture,
	ListItemDefaultPicture
  },
  computed: {
    addClass() {
      return `is-${this.item.category}`;
	},
	addId() {
      return `item${this.item.id}`;
	},
	addIdAnker() {
      return `#${this.item.id}`;
    },
    bindAria(till) {
      if (till) {
        return till;
      } else {
        return "";
      }
    }
  }
};
</script>
